export const FILES_TYPES = {
    MOL: 'mol',
    NMRIUM: 'nmrium',
    JSON: 'json',
    DX: 'dx',
    JDX: 'jdx',
    JDF: 'jdf',
    ZIP: 'zip',
    NMREDATA: 'nmredata',
};
//# sourceMappingURL=constants.js.map